import React from 'react';
import { useIntl } from 'react-intl';

import { BannerStatus, BannerLayout } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import style from './style.module.less';
import { ApiKey } from '../../api-key';

/**
 * This component renders a summary of the created API Key.
 * @param {object} props
 * @param {import('../../../types/api-keys').APIKeysV1} props.createdApiKey
 * @returns {JSX.Element} The rendered component.
 */
export const CreatedSummary = ({ createdApiKey }) => {
  const intl = useIntl();

  return (
    <>
      <BannerMessageV2
        className={style['summary-warning-banner']}
        content={
          <Text
            element='p'
            textType={TextType.Paragraph}
            value={intl.formatMessage(messages.storeSecurelyMessage, {
              strong: (...chunks) => <strong>{chunks}</strong>,
            })}
          />
        }
        layout={BannerLayout.Inline}
        status={BannerStatus.Info}
      />

      <ApiKey
        className={style['summary-api-key']}
        title={intl.formatMessage(messages.apiKeyLabel)}
        value={createdApiKey.key}
        valueTextClassName={style['summary-api-key-copy-to-clipboard']}
      />

      <ApiKey
        className={style['summary-api-key']}
        title={intl.formatMessage(messages.secretKeyLabel)}
        value={createdApiKey.secret}
        valueTextClassName={style['summary-api-key-copy-to-clipboard']}
      />
    </>
  );
};
